import { MyHttpClient } from '../http-client';
import { throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import * as i0 from "@angular/core";
import * as i1 from "../http-client";
export var INCENTIVE_APPROVAL_PREVIEW_KEY_PREFIX = 'incentive-approval-preview:';
var IncentiveApprovalRequestsService = /** @class */ (function () {
    function IncentiveApprovalRequestsService(http) {
        this.http = http;
        this.baseUrl = environment.server + "/api/incentive-approval-requests";
    }
    IncentiveApprovalRequestsService.prototype.fetchApprovalRequestById = function (requestId) {
        return this.http.get(this.baseUrl + "/" + requestId)
            .pipe(map(function (res) { return res.data || res.response || res; }))
            .pipe(catchError(this.handleError));
    };
    IncentiveApprovalRequestsService.prototype.fetchApprovalRequests = function (params) {
        var query = new URLSearchParams({
            pageNumber: String(params.pageNumber),
            pageLimit: String(params.pageLimit),
        });
        if (params.requestStatus) {
            query.set('requestStatus', params.requestStatus);
        }
        if (params.cities && params.cities.length) {
            query.set('cities', params.cities.join(','));
        }
        if (params.serviceTypes && params.serviceTypes.length) {
            query.set('serviceTypes', params.serviceTypes.join(','));
        }
        if (params.types && params.types.length) {
            query.set('types', params.types.join(','));
        }
        if (params.operations && params.operations.length) {
            query.set('operations', params.operations.join(','));
        }
        if (params.fromDate) {
            query.set('fromDate', params.fromDate);
        }
        if (params.toDate) {
            query.set('toDate', params.toDate);
        }
        if (params.sortBy) {
            query.set('sortBy', params.sortBy);
            query.set('sortOrder', String(params.sortOrder == null ? -1 : params.sortOrder));
        }
        return this.http.get(this.baseUrl + "?" + query.toString())
            .pipe(map(function (res) {
            var rows = res.data || res.response || [];
            return {
                data: rows,
                documentCount: res.documentCount != null ? res.documentCount : rows.length,
            };
        }))
            .pipe(catchError(this.handleError));
    };
    IncentiveApprovalRequestsService.prototype.storePreviewForRequest = function (requestId, context) {
        var payload = context.newValue != null
            ? context
            : { requestId: requestId, newValue: context };
        sessionStorage.setItem("" + INCENTIVE_APPROVAL_PREVIEW_KEY_PREFIX + requestId, JSON.stringify(payload));
    };
    IncentiveApprovalRequestsService.prototype.approveRequest = function (requestId, body) {
        return this.http.post(this.baseUrl + "/" + requestId + "/approve", body)
            .pipe(map(function (res) { return res; }))
            .pipe(catchError(this.handleError));
    };
    IncentiveApprovalRequestsService.prototype.rejectRequest = function (requestId, body) {
        return this.http.post(this.baseUrl + "/" + requestId + "/reject", body)
            .pipe(map(function (res) { return res; }))
            .pipe(catchError(this.handleError));
    };
    IncentiveApprovalRequestsService.prototype.handleError = function (error) {
        console.error('Failed to fetch incentive approval requests', error);
        return throwError(error);
    };
    IncentiveApprovalRequestsService.ngInjectableDef = i0.defineInjectable({ factory: function IncentiveApprovalRequestsService_Factory() { return new IncentiveApprovalRequestsService(i0.inject(i1.MyHttpClient)); }, token: IncentiveApprovalRequestsService, providedIn: "root" });
    return IncentiveApprovalRequestsService;
}());
export { IncentiveApprovalRequestsService };
